import { 
	AuthRepository,
} from "../../api";

export class ResetPasswordController {
    constructor(_callback, _getState, _router) {
        this.callback = _callback;
        this.getState = _getState;
        this.router = _router;

        this.authRepo = new AuthRepository();

        this.changeAction = this.changeAction.bind(this);
        this.submitAction = this.submitAction.bind(this);
    }

    changeAction(e) {
        const { getState, callback } = this;
        const { value, id } = e.target;

        const state = getState();
        state[id] = value;
        callback(state);
    }

    async submitAction(e) {
        e.preventDefault();
        const { PASSWORD, CONFIRM_PASSWORD } = this.getState();

        if(PASSWORD != CONFIRM_PASSWORD)
            return this.callback({ ERROR: "As senhas digitadas não conferem!" });

        const { user_id, token } = this.router.location.query;
        const body = { password: PASSWORD };
        const promise = await this.authRepo.resetPassword(user_id, token, body);

        if(promise.error) {
            this.callback({ ERROR: "Houve um erro em nosso servidores" });
        } else {
            this.router.push("/");
        }

    }

}


// WEBPACK FOOTER //
// src/controllers/lib/ResetPasswordController.js